import * as React from "react";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { withApollo, graphql, compose } from "react-apollo";
import { gql } from "apollo-boost";
import withCurrentUser from "../../hocs/withCurrentUser";
import { logOut } from "../../ducks/auth";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverContentItem
} from "../Popover";
import Avatar from "../Avatar";

const RoundPopoverTrigger = styled(PopoverTrigger)`
  border-radius: 50%;
`;

class AccountMenu extends React.Component {
  handleSelection = (value, e) => {
    value(e);
  };

  navigateToAdmin = e => {
    if (e) e.preventDefault();
    this.props.history.push("/admin");
  };

  openSettings = e => {
    if (e) e.preventDefault();
    console.log("Opening settings");
  };

  signOut = e => {
    if (e) e.preventDefault();
    this.props.history.push("/login");
    setTimeout(() => {
      this.props.logOut();
      this.props.client.resetStore();
    }, 1);
  };

  render() {
    const { style, userData: { currentUser } } = this.props;

    return (
      <Popover onSelection={this.handleSelection} style={style}>
        <RoundPopoverTrigger aria-label="Account menu">
          <Avatar
            email={currentUser ? currentUser.email : ""}
            style={{ display: "block", width: 32, height: 32 }}
          />
        </RoundPopoverTrigger>
        <PopoverContent>
          <PopoverContentItem value={this.signOut}>Sign out</PopoverContentItem>
        </PopoverContent>
      </Popover>
    );
  }
}

const enhance = compose(
  withRouter,
  connect(null, {
    logOut
  }),
  withApollo,
  withCurrentUser()
);

export default enhance(AccountMenu);



// WEBPACK FOOTER //
// ./src/components/topbar/AccountMenu.js